import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import QuizGame from "./components/QuizGame";
import QuestionHelper from "./components/QuestionHelper";
import QuestionHelperSetup from "./components/QuestionHelperSetup";
import QuestionHelperAdmin from "./components/QuestionHelperAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<QuizGame />} />
          <Route path="/igcse-geography/question-helper" element={<Navigate to="/igcse-geography/question-helper/setup" replace />} />
          <Route path="/igcse-geography/question-helper/setup" element={<QuestionHelperSetup />} />
          <Route path="/igcse-geography/question-helper/session" element={<QuestionHelper />} />
          <Route path="/admin/question-helper" element={<QuestionHelperAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
